import { TodosSubmissionsStatus } from "@profile-service-types/index.ts";

/** Synthetic display-only status for archived to-dos — never sent to the API. */
export const ARCHIVED_STATUS = "Archived" as const;

export type DisplayableStatus = TodosSubmissionsStatus | typeof ARCHIVED_STATUS;

export const STATUS_DISPLAY: Record<DisplayableStatus, string> = {
  [TodosSubmissionsStatus.NotSubmitted]: "Not Submitted",
  [TodosSubmissionsStatus.AwaitingResponse]: "Awaiting Response",
  [TodosSubmissionsStatus.WaitingOnOthers]: "Awaiting Delivery",
  [TodosSubmissionsStatus.Completed]: "Completed",
  [TodosSubmissionsStatus.RequiresAChange]: "Not Accepted",
  [TodosSubmissionsStatus.SubmittedForReview]: "Needs Review",
  [ARCHIVED_STATUS]: "Archived",
};

export const STATUS_COLOR_CLASSES: Record<DisplayableStatus, { dot: string; text: string }> = {
  [TodosSubmissionsStatus.NotSubmitted]: { dot: "bg-info-900", text: "text-info-900" },
  [TodosSubmissionsStatus.AwaitingResponse]: { dot: "bg-warning-900", text: "text-warning-900" },
  [TodosSubmissionsStatus.WaitingOnOthers]: { dot: "bg-warning-900", text: "text-warning-900" },
  [TodosSubmissionsStatus.SubmittedForReview]: { dot: "bg-warning-900", text: "text-warning-900" },
  [TodosSubmissionsStatus.RequiresAChange]: { dot: "bg-error-900", text: "text-error-900" },
  [TodosSubmissionsStatus.Completed]: { dot: "bg-success-800", text: "text-success-800" },
  [ARCHIVED_STATUS]: { dot: "bg-gray-600", text: "text-gray-600" },
};

/** Option order from the design; "Not Submitted" is never offered. */
const STATUS_OPTION_ORDER: TodosSubmissionsStatus[] = [
  TodosSubmissionsStatus.WaitingOnOthers,
  TodosSubmissionsStatus.AwaitingResponse,
  TodosSubmissionsStatus.Completed,
  TodosSubmissionsStatus.SubmittedForReview,
  TodosSubmissionsStatus.RequiresAChange,
];

export const getStatusOptions = (permittedStatuses: TodosSubmissionsStatus[] | undefined): TodosSubmissionsStatus[] =>
  STATUS_OPTION_ORDER.filter((status) => (permittedStatuses ?? []).includes(status));

/**
 * Zero state (no submission yet): the advisor may only mark the to-do
 * Completed (via a status override) or return it to Not Submitted (override
 * cleared). Unlike the normal option set, "Not Submitted" IS selectable here.
 */
const ZERO_STATE_OPTION_ORDER: TodosSubmissionsStatus[] = [
  TodosSubmissionsStatus.NotSubmitted,
  TodosSubmissionsStatus.Completed,
];

export const getZeroStateStatusOptions = (
  permittedStatuses: TodosSubmissionsStatus[] | undefined,
): TodosSubmissionsStatus[] => ZERO_STATE_OPTION_ORDER.filter((status) => (permittedStatuses ?? []).includes(status));
